import type { ReceiptTemplate } from '../schema';

export const autozoneTemplate: ReceiptTemplate = {
  id: 'autozone',
  name: 'AutoZone Receipt',
  brand: 'AUTOZONE',
  description: 'AutoZone auto parts store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'az-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/autozone.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'STORE #4892',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'az-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans:', value: '847291' },
        ],
        column2: [
          { id: 'date', label: '', value: '01/04/2026 2:45PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'az-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'DURALAST BATTERY', quantity: '1', price: '149.99', sku: '847291034' },
          { id: '2', name: 'BATTERY TERMINAL', quantity: '1', price: '8.99', sku: '847291035' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'az-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '158.98', isBold: false, isLarge: false },
          { id: 'core', label: 'CORE DEPOSIT', value: '22.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '14.93', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '195.91', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'az-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'az-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'AUTOZONE REWARDS\n\nFREE BATTERY INSTALLATION\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

